export default __webpack_public_path__ + "static/generative-ai-v-990200a07a2fef155ada7924852e44b3.webp";